import { render, staticRenderFns } from "./PokemonList.vue?vue&type=template&id=3c6b4b9a&scoped=true"
import script from "./PokemonList.vue?vue&type=script&lang=js"
export * from "./PokemonList.vue?vue&type=script&lang=js"
import style0 from "./PokemonList.vue?vue&type=style&index=0&id=3c6b4b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6b4b9a",
  null
  
)

export default component.exports